import Cookies from 'js-cookie'

const TOKEN_KEY = 'auth_token'

export const setTokenCookie = (token: string) => {
  Cookies.set(TOKEN_KEY, token, {
    expires: 1,           // match your backend JWT lifetime
    secure: true,
    sameSite: 'strict',   // add this
  })
}

export const getTokenCookie = () => {
  return Cookies.get(TOKEN_KEY)
}

export const removeTokenCookie = () => {
  Cookies.remove(TOKEN_KEY)
}
